module.exports = __webpack_public_path__ + "static/media/unsuccess.8abaa59e.svg";